module.exports = __webpack_public_path__ + "img/fluid-wagon.d670f7e5.png";